export type ReleaseInfoAccessUser = {
  role?: string | null;
  roles?: string[] | null;
  cognitoGroups?: string[] | null;
};

export const DEFAULT_RELEASE_INFO_ROLES = [
  "Engineering",
] as const;

export const ENGINEERING_ROLE = "Engineering" as const;
export const PRODUCT_ROLE = "Product" as const;

function normalizeRoleValues(values: Array<string | null | undefined>) {
  return values
    .flatMap((value) => value?.split(/[,;]/) ?? [])
    .map((value) => value.trim())
    .filter(Boolean);
}

export function isReleaseInfoUser(
  user: ReleaseInfoAccessUser | null | undefined,
  allowedRoles: readonly string[] = DEFAULT_RELEASE_INFO_ROLES,
) {
  if (!user) {
    return false;
  }

  const allowedRoleSet = new Set(allowedRoles);

  return normalizeRoleValues([
    user.role,
    ...(user.roles ?? []),
    ...(user.cognitoGroups ?? []),
  ]).some((role) => allowedRoleSet.has(role));
}

export function isEngineeringUser(user: ReleaseInfoAccessUser | null | undefined) {
  return isReleaseInfoUser(user, [ENGINEERING_ROLE]);
}

export function isEngineeringOrProductUser(
  user: ReleaseInfoAccessUser | null | undefined,
) {
  return isReleaseInfoUser(user, [ENGINEERING_ROLE, PRODUCT_ROLE]);
}
